module.exports = __webpack_public_path__ + "static/media/scores-icon.d07cf5d1.svg";